// ===============================
// Sticky ATC behavior controller
// ===============================

const bottomATC = document.querySelector('.bottom-atc');
const mainATC = document.querySelector('.product-action .addToCartBtn');

let lastScrollY = window.scrollY;
let scrollingUp = false;
let mainATCVisible = true;
let passedMainATC = false;

// --- Observe main ATC visibility ---
const observer = new IntersectionObserver(
  ([entry]) => {
    mainATCVisible = entry.isIntersecting;

    // Always hide sticky when main ATC is visible
    if (mainATCVisible) {
      bottomATC.classList.remove('show');
      bottomATC.classList.add('hide');
    }
  },
  { threshold: 0 }
);

observer.observe(mainATC);

// --- Scroll direction & position detection ---
window.addEventListener('scroll', () => {
  const currentScrollY = window.scrollY;

  scrollingUp = currentScrollY < lastScrollY;
  lastScrollY = currentScrollY;

  const mainATCBottom =
    mainATC.getBoundingClientRect().bottom + window.scrollY;

  passedMainATC = currentScrollY > mainATCBottom;

  // --- Visibility rules ---
  if (
    passedMainATC &&
    scrollingUp &&
    !mainATCVisible
  ) {
    bottomATC.classList.add('show');
    bottomATC.classList.remove('hide');
  } else {
    bottomATC.classList.remove('show');
    bottomATC.classList.add('hide');
  }
});